import { render, staticRenderFns } from "./EventStudentsReport.vue?vue&type=template&id=312f2464&scoped=true&"
import script from "./EventStudentsReport.vue?vue&type=script&lang=js&"
export * from "./EventStudentsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312f2464",
  null
  
)

export default component.exports